<template>
  <div id="footer">
    <div id="contacts">
      <div class="footer-font">
        <p>
          Ufficio Gestione e Valorizzazione dei Beni del Patrimonio culturale e museale<br/>
          Direzione Innovazione e Valorizzazione delle Conoscenze<br/><br/>
          Università degli Studi di Milano<br/>
          Via Festa del Perdono 7 – 20122 Milano<br/><br/>
          <font-awesome-icon class="contacts" :icon="iconPhone" />02 503 12717<br/>
          <font-awesome-icon class="contacts" :icon="iconMail" />
          <a href="mailto:patrimonioculturale.museale@unimi.it">patrimonioculturale.museale@unimi.it</a>
        </p>
      </div>
    </div>
    <div id="socials">
      <a href="https://www.youtube.com/@UnimiVideo" target="_blank"><font-awesome-icon class="social" :icon="iconYoutube" /></a>
      <hr style="border-top: 1px solid white;">
      <p style="font-size: 14px;margin: 10px 0;text-align: center">
        <b-link href="https://www.unimi.it/it/accessibilita">{{ $t('accessibilita') }}</b-link>
<!-- TODO: Accettazione cookies -->
      </p>
      <p style="font-size: 14px;margin: 10px 0;text-align: center">
        <b-link href="https://www.unimi.it/it/privacy-e-cookie">{{ $t('cookies') }}</b-link>
        <cookie-law buttonDecline :buttonText="$t('cookies_accetta')" :buttonDeclineText="$t('cookies_rifiuta')">
          <div slot="message">
            {{ $t('cookies_messaggio') }}
          </div>
        </cookie-law>
      </p>
    </div>
    <div>
      <img src="../assets/vumm.png" style="height: 70px; vertical-align: auto" alt="Logo Museo Virtuale">
    </div>
  </div>
</template>

<script>

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPhone, faAt } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faInstagram, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons'
import CookieLaw from 'vue-cookie-law'

export default {
  name: 'Footer',

  data () {
    return {
      iconFacebook: faFacebook,
      iconInstagram: faInstagram,
      iconTwitter: faTwitter,
      iconYoutube: faYoutube,
      iconPhone: faPhone,
      iconMail: faAt
    }
  },

  components: {
    FontAwesomeIcon,
    CookieLaw
  }
}

</script>